(function() {
	'use strict';

	angular
		.module('app.leanProjects')
		.directive('kanbanVirtualColumn', kanbanVirtualColumn);

	kanbanVirtualColumn.$inject = ['$parse', '$timeout', 'kanbanDragService'];

	function kanbanVirtualColumn($parse, $timeout, kanbanDragService) {
		var ESTIMATED_ROW_HEIGHT = 92;
		var OVERSCAN = 6;

		return {
			restrict: 'A',
			link: link
		};

		function link(scope, element, attrs) {
			var container = element[0];
			var listGetter = $parse(attrs.kanbanVirtualColumn);
			var onCardDrop = attrs.onCardDrop ? $parse(attrs.onCardDrop) : null;

			var heights = {};
			var measuredSum = 0;
			var measuredCount = 0;
			var offsets = [0];
			var offsetsDirty = true;
			var lastLength = -1;
			var rafId = null;

			scope.visibleCards = [];
			scope.padTop = 0;
			scope.padBottom = 0;

			function getList() {
				var list = listGetter(scope);
				return angular.isArray(list) ? list : [];
			}

			function estimate() {
				return measuredCount > 0 ? measuredSum / measuredCount : ESTIMATED_ROW_HEIGHT;
			}

			function itemHeight(project) {
				var h = project ? heights[project.projNdx] : undefined;
				return h !== undefined ? h : estimate();
			}

			function rebuildOffsets(list) {
				var total = list.length;
				offsets = new Array(total + 1);
				offsets[0] = 0;
				for (var i = 0; i < total; i++) {
					offsets[i + 1] = offsets[i] + itemHeight(list[i]);
				}
				offsetsDirty = false;
			}

			function findStart(scrollTop) {
				var lo = 0;
				var hi = offsets.length - 1;
				while (lo < hi) {
					var mid = (lo + hi + 1) >> 1;
					if (offsets[mid] <= scrollTop) {
						lo = mid;
					} else {
						hi = mid - 1;
					}
				}
				return lo;
			}

			function findEnd(bottom, total) {
				var lo = 0;
				var hi = total;
				while (lo < hi) {
					var mid = (lo + hi) >> 1;
					if (offsets[mid] < bottom) {
						lo = mid + 1;
					} else {
						hi = mid;
					}
				}
				return lo;
			}

			function render() {
				var list = getList();
				var total = list.length;

				if (total !== lastLength) {
					offsetsDirty = true;
					lastLength = total;
				}
				if (offsetsDirty) {
					rebuildOffsets(list);
				}

				var start = 0;
				var end = 0;
				if (total > 0) {
					var viewport = container.clientHeight || 0;
					var scrollTop = container.scrollTop || 0;
					start = Math.max(0, findStart(scrollTop) - OVERSCAN);
					end = Math.min(total, findEnd(scrollTop + viewport, total) + OVERSCAN);
				}

				scope.visibleCards = list.slice(start, end);
				scope.padTop = offsets[start];
				scope.padBottom = Math.max(0, offsets[total] - offsets[end]);

				if (!scope.$$phase && !scope.$root.$$phase) {
					scope.$digest();
				}

				window.requestAnimationFrame(function() { measureVisible(list, start); });
			}

			function measureVisible(list, start) {
				var cards = container.querySelectorAll('.kanban-card');
				var changed = false;
				for (var i = 0; i < cards.length; i++) {
					var project = list[start + i];
					if (!project) {
						continue;
					}
					var style = window.getComputedStyle(cards[i]);
					var marginTop = parseFloat(style.marginTop) || 0;
					var marginBottom = parseFloat(style.marginBottom) || 0;
					var h = cards[i].getBoundingClientRect().height + marginTop + marginBottom;
					if (h <= 0) {
						continue;
					}
					var prev = heights[project.projNdx];
					if (prev === undefined) {
						measuredSum += h;
						measuredCount++;
						changed = true;
					} else if (Math.abs(prev - h) > 0.5) {
						measuredSum += h - prev;
						changed = true;
					}
					heights[project.projNdx] = h;
				}
				if (changed) {
					offsetsDirty = true;
					scheduleRender();
				}
			}

			function scheduleRender() {
				if (rafId) {
					return;
				}
				rafId = window.requestAnimationFrame(function() {
					rafId = null;
					render();
				});
			}

			container.addEventListener('scroll', scheduleRender);

			container.addEventListener('dragover', function(event) {
				if (kanbanDragService.get()) {
					event.preventDefault();
					if (event.dataTransfer) {
						event.dataTransfer.dropEffect = 'move';
					}
				}
			});
			container.addEventListener('drop', function(event) {
				var dragged = kanbanDragService.get();
				if (!dragged || !onCardDrop) {
					return;
				}
				event.preventDefault();
				scope.$apply(function() {
					onCardDrop(scope, { $project: dragged });
				});
				kanbanDragService.clear();
			});

			function onListChanged() {
				offsetsDirty = true;
				scheduleRender();
			}

			// A filter change swaps the array; a card move splices it in place.
			scope.$watch(function() { return getList(); }, onListChanged);
			scope.$watch(function() { return getList().length; }, onListChanged);

			var resizeObserver;
			if (window.ResizeObserver) {
				resizeObserver = new window.ResizeObserver(function() {
					heights = {};
					measuredSum = 0;
					measuredCount = 0;
					offsetsDirty = true;
					scheduleRender();
				});
				resizeObserver.observe(container);
			}

			scope.$on('$destroy', function() {
				container.removeEventListener('scroll', scheduleRender);
				if (resizeObserver) {
					resizeObserver.disconnect();
				}
				if (rafId) {
					window.cancelAnimationFrame(rafId);
				}
			});

			$timeout(render);
		}
	}
})();
